const STORAGE_KEY = 'theme';
const THEME_TOGGLE_ENABLED = false;

function getSystemTheme() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function getStoredTheme() {
    return localStorage.getItem(STORAGE_KEY);
}

function getEffectiveTheme() {
    const stored = getStoredTheme();
    if (stored === 'dark' || stored === 'light') {
        return stored;
    }
    return getSystemTheme();
}

function applyTheme(theme) {
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(theme);
}

function initTheme() {
    if (!THEME_TOGGLE_ENABLED) {
        return;
    }

    const theme = getEffectiveTheme();
    applyTheme(theme);
}

function toggleTheme() {
    if (!THEME_TOGGLE_ENABLED) {
        return;
    }

    const current = getEffectiveTheme();
    const next = current === 'dark' ? 'light' : 'dark';
    localStorage.setItem(STORAGE_KEY, next);
    applyTheme(next);
}

function syncDummyClass(textarea) {
    if (!(textarea instanceof HTMLTextAreaElement)) {
        return;
    }

    const hasInput = textarea.value.trim().length > 0;
    textarea.classList.toggle('vehicle__card-paste--active', hasInput);
}

function initDummyTextareas() {
    document.querySelectorAll('[data-action="textarea:is_empty"]').forEach(syncDummyClass);
}

document.addEventListener('DOMContentLoaded', () => {
    initTheme();
    initDummyTextareas();
    initDanishKrInputs();

    document.addEventListener('click', (e) => {
        const action = e.target.closest('[data-action]')?.getAttribute('data-action');
        if (action === 'theme:toggle') {
            e.preventDefault();
            toggleTheme();
        }
    });

    document.addEventListener('input', (e) => {
        const target = e.target;
        if (target instanceof HTMLTextAreaElement && target.matches('[data-action="textarea:is_empty"]')) {
            syncDummyClass(target);
        }
    });
});

document.addEventListener('livewire:navigated', () => {
    initDummyTextareas();
    initDanishKrInputs();
});

// ─── Danish price inputs (custom equipment list_price): raw on focus, formatted on blur ───

const DK_KR_SELECTOR = '[data-action="input:dk-kr"]';

/**
 * Parse user input that may use Danish grouping (.) and decimal (,).
 */
function parseDanishNumber(value) {
    let s = String(value ?? '')
        .replace(/\s/g, '')
        .trim();
    if (s === '') {
        return 0;
    }

    const commaIndex = s.lastIndexOf(',');
    if (commaIndex !== -1) {
        const intPart = s.slice(0, commaIndex).replace(/\./g, '');
        const decPart = s.slice(commaIndex + 1).replace(/\./g, '');
        const n = parseFloat(`${intPart}.${decPart}`);
        return Number.isFinite(n) ? n : 0;
    }

    const parts = s.split('.');
    if (parts.length === 2 && parts[1].length <= 2 && parts[0].length <= 3) {
        const n = parseFloat(`${parts[0]}.${parts[1]}`);
        return Number.isFinite(n) ? n : 0;
    }

    const collapsed = s.replace(/\./g, '');
    const n = parseFloat(collapsed);
    return Number.isFinite(n) ? n : 0;
}

function formatDanishNumber(value) {
    const n = typeof value === 'number' ? value : parseDanishNumber(value);
    return new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(n);
}

/** Plain numeric string for editing (no thousand separators). */
function toRawEditValue(value) {
    const n = parseDanishNumber(value);
    if (n === 0 && String(value ?? '').replace(/\s/g, '').trim() === '') {
        return '';
    }
    if (Number.isInteger(n) || Math.abs(n - Math.round(n)) < 1e-9) {
        return String(Math.round(n));
    }
    return String(n);
}

function isDkKrInput(el) {
    return el instanceof HTMLInputElement && el.matches(DK_KR_SELECTOR);
}

/** Set value Livewire can sync (no thousand separators). */
function syncCleanNumericToWire(input) {
    const n = parseDanishNumber(input.value);
    input.value = n === 0 && input.value.replace(/\s/g, '').trim() === '' ? '' : String(n);
}

function formatDkKrInputDisplay(input) {
    if (!isDkKrInput(input)) {
        return;
    }
    if (input === document.activeElement || input.dataset.dkKrEditing === '1') {
        return;
    }
    const raw = input.value.trim();
    if (raw === '') {
        return;
    }
    const n = parseDanishNumber(raw);
    input.value = formatDanishNumber(n);
}

function initDanishKrInputs() {
    document.querySelectorAll(DK_KR_SELECTOR).forEach((el) => {
        if (el instanceof HTMLInputElement) {
            formatDkKrInputDisplay(el);
        }
    });
}

document.addEventListener('focusin', (e) => {
    const t = e.target;
    if (!isDkKrInput(t)) {
        return;
    }
    t.dataset.dkKrEditing = '1';
    t.value = toRawEditValue(t.value);
}, true);

document.addEventListener('focusout', (e) => {
    const t = e.target;
    if (!isDkKrInput(t)) {
        return;
    }
    delete t.dataset.dkKrEditing;
    syncCleanNumericToWire(t);
}, true);

document.addEventListener('livewire:init', () => {
    if (typeof window.Livewire === 'undefined' || typeof window.Livewire.hook !== 'function') {
        return;
    }
    window.Livewire.hook('morph.updated', () => {
        requestAnimationFrame(() => initDanishKrInputs());
    });
});
